module.exports = {"469021100":"定城镇","469021101":"新竹镇","469021102":"龙湖镇","469021103":"黄竹镇","469021104":"雷鸣镇","469021105":"龙门镇","469021106":"龙河镇","469021107":"岭口镇","469021108":"翰林镇","469021109":"富文镇","469021400":"国营中瑞农场","469021401":"国营南海农场","469021402":"国营金鸡岭农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469021.json
// module id = 2025
// module chunks = 0